import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input', 'showButton', 'hideButton']

  show = () => {
    this.inputTarget.type = "text"
    this.showButtonTarget.classList.add('hidden')
    this.hideButtonTarget.classList.remove('hidden')
  }

  showButtonTargetConnected = (element) => {
    element.addEventListener('click', this.show)
  }

  hide = () => {
    this.inputTarget.type = "password"
    this.showButtonTarget.classList.remove('hidden')
    this.hideButtonTarget.classList.add('hidden')
  }

  hideButtonTargetConnected = (element) => {
    element.addEventListener('click', this.hide)
  }
}
